import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  Button,
  Paper,
  List,
  ListItem,
} from "@material-ui/core";
import { Link } from "react-router-dom";

const STORAGE_KEY = "recentDevices";

export default function DeviceSearch({
  value,
  setValue,
  handleSubmit,
  handleClear,
}) {
  const [recentDevices, setRecentDevices] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [emptyValue, setEmptyValue] = useState(true);
  const containerRef = useRef(null);

  useEffect(
    () =>
      setEmptyValue(!value || typeof value !== "string" || value.trim() === ""),
    [value]
  );

  // Load recent devices from localStorage on mount
  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    setRecentDevices(stored);
  }, []);

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsFocused(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      if (e.shiftKey) {
        return; // allow newline with Shift+Enter
      } else {
        e.preventDefault();
        if (!emptyValue) {
          handleSubmit();
          setIsFocused(false);
        }
      }
    }
  };

  const onRecentClick = (device) => {
    setValue(device);
    handleSubmit();
    setIsFocused(false);
  };

  return (
    <div ref={containerRef} style={{ position: "relative", width: "100%" }}>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        spacing={4}
        alignItems="center"
      >
        <Grid item xs={12} md={6} lg={6} style={{ position: "relative" }}>
          <TextField
            id="device_id"
            label="Search Device by name, mac, serial no, m1 iccid or label"
            variant="outlined"
            fullWidth
            value={value}
            onChange={(e) => setValue(e.target.value)}
            size="small"
            disableAutoFocus
            multiline
            onKeyDown={onKeyDown}
            onFocus={() => setIsFocused(true)}
            autoComplete="off"
          />

          {/* Dropdown for recent devices */}
          {isFocused && recentDevices.length > 0 && (
            <Paper
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                maxHeight: 200,
                overflowY: "auto",
                zIndex: 10,
              }}
              square
              elevation={4}
            >
              <List dense>
                <ListItem>
                  <strong>Recent Devices</strong>
                </ListItem>
                {recentDevices.map((device, idx) => (
                  <ListItem
                    key={idx}
                    button
                    component={Link}
                    to={`/device/${encodeURIComponent(device.uuid)}/info`}
                    onClick={() => onRecentClick(device)}
                  >
                    {`${device?.serial}`}
                  </ListItem>
                ))}
              </List>
            </Paper>
          )}
        </Grid>

        <Grid item>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              handleSubmit();
              setIsFocused(false);
            }}
            disabled={emptyValue}
          >
            Search
          </Button>
        </Grid>

        <Grid item>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              handleClear();
              setIsFocused(false);
            }}
            disabled={emptyValue}
          >
            Clear Search
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
